import { toPath } from "lodash";

/**
 * `state` with `value` at `path`, copying only the objects along the path: everything else is shared, not
 * deep-copied. Session and batch records hold whole solve results (which can be hundreds of MB), so a deep copy of
 * the store on every action froze the page (e.g. pressing Run in the debugger, before the request was even sent).
 */
export const setIn = (state, path, value) => {
  const keys = toPath(path);
  const root = { ...state };
  let copy = root;
  let original = state;
  for (const key of keys.slice(0, -1)) {
    const next = original?.[key];
    copy[key] = next && typeof next === "object" ? { ...next } : {};
    copy = copy[key];
    original = next;
  }
  copy[keys[keys.length - 1]] = value;
  return root;
};
